import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { LuMenu } from 'react-icons/lu';
import { trackNavigation, trackButtonClick } from '../utils/analytics';
import styles from './Navbar.module.css';

const AppName = () => (
      <div className={styles.appName}>
    <Link
      to="/"
      className={styles.navLink}
      onClick={() => trackNavigation('BENJAMIN CLEEK', '/')}
    >
      BENJAMIN CLEEK
    </Link>
  </div>
);

const Description = () => (
  <div className={styles.description}>
  </div>
);

const MOBILE_NAV_BREAKPOINT = 900;

function Navbar() {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [showMobileMenuIcon, setShowMobileMenuIcon] = useState(window.innerWidth <= MOBILE_NAV_BREAKPOINT);
  const workDetailsRef = useRef(null);
  const navRef = useRef(null);

  const toggleMenu = () => {
    trackButtonClick('mobile_menu_toggle', 'Navbar');
    setMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    workDetailsRef.current?.removeAttribute('open');
    setMenuOpen(false);
  };

  const handleResize = () => {
    setShowMobileMenuIcon(window.innerWidth <= MOBILE_NAV_BREAKPOINT);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (!showMobileMenuIcon) {
      setMenuOpen(false);
    }
  }, [showMobileMenuIcon]);

  useEffect(() => {
    const handlePointerDown = (event) => {
      const outsideNav = !navRef.current?.contains(event.target);
      if (workDetailsRef.current?.hasAttribute('open') && outsideNav) {
        workDetailsRef.current.removeAttribute('open');
      }
      if (isMenuOpen && outsideNav) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('pointerdown', handlePointerDown);

    return () => {
      document.removeEventListener('pointerdown', handlePointerDown);
    };
  }, [isMenuOpen]);

  return (
    <nav ref={navRef} className={styles.Navbar}>
      <AppName />
      <Description />
      {showMobileMenuIcon && (
        <button
          type="button"
          className={styles.mobileMenuIcon}
          onClick={(e) => { e.stopPropagation(); toggleMenu(); }}
          aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
          aria-expanded={isMenuOpen}
        >
          <LuMenu />
        </button>
      )}
      {(!showMobileMenuIcon || isMenuOpen) && (
        <ul className={`${styles.navbarNav} ${isMenuOpen ? styles.showMenu : ''}`}>
          <li className={styles.navbarItem} onClick={closeMenu}>
            <Link
              to="/experimental"
              className={styles.navLink}
              onClick={() => trackNavigation('Experimental', '/experimental')}
            >
              Experimental
            </Link>
          </li>
          <li className={styles.navbarItem}>
            <details ref={workDetailsRef} className={styles.workDetails}>
              <summary className={`${styles.navLink} ${styles.workSummary}`}>
                Work
              </summary>
              <ul className={styles.workSubmenu}>
                <li className={styles.workSubmenuItem}>
                  <Link
                    to="/Film/filmscores"
                    className={styles.navLink}
                    onClick={(e) => {
                      trackNavigation('Film', '/Film/filmscores');
                      e.currentTarget.closest('details')?.removeAttribute('open');
                      closeMenu();
                    }}
                  >
                    Film
                  </Link>
                </li>
                <li className={styles.workSubmenuItem}>
                  <Link
                    to="/music"
                    className={styles.navLink}
                    onClick={(e) => {
                      trackNavigation('Music', '/music');
                      e.currentTarget.closest('details')?.removeAttribute('open');
                      closeMenu();
                    }}
                  >
                    Music
                  </Link>
                </li>
                <li className={styles.workSubmenuItem}>
                  <Link
                    to="/commercial"
                    className={styles.navLink}
                    onClick={(e) => {
                      trackNavigation('Commercial', '/commercial');
                      e.currentTarget.closest('details')?.removeAttribute('open');
                      closeMenu();
                    }}
                  >
                    Commercial
                  </Link>
                </li>
              </ul>
            </details>
          </li>
          <li className={styles.navbarItem} onClick={closeMenu}>
            <Link
              to="/collaborations"
              className={styles.navLink}
              onClick={() => trackNavigation('Collaborations', '/collaborations')}
            >
              Collaborations
            </Link>
          </li>
          <li className={styles.navbarItem} onClick={closeMenu}>
            <Link
              to="/bio"
              className={styles.navLink}
              onClick={() => trackNavigation('Bio', '/bio')}
            >
              Bio
            </Link>
          </li>
          <li className={styles.navbarItem} onClick={closeMenu}>
            <Link
              to="/contact"
              className={styles.navLink}
              onClick={() => trackNavigation('Contact', '/contact')}
            >
              Contact
            </Link>
          </li>
          {/* <li className={styles.navbarItem} onClick={closeMenu}>
            <Link to="/devportfolio" className={styles.navLink}>
              dev portfolio
            </Link>
          </li> */}

          {/* <li className={styles.navbarItem} onClick={closeMenu}>
            <Link to="/Admin" className={styles.navLink}>
              Admin
            </Link>
          </li> */}
        </ul>
      )}
    </nav>
  );
}

export default Navbar;
